import { MensajesService } from './../../services/mensajes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mensajes',
  templateUrl: './mensajes.component.html',
  styleUrls: ['./mensajes.component.css']
})
export class MensajesComponent implements OnInit {

  mensajesEnviados;
  mensajesRecibidos;
  paginaActualRecibidos:number;
  paginaSiguienteRecibidos:number;
  paginaAnteriorRecibidos:number;
  totalPaginasRecibidos:number;
  paginaActualEnviados:number;
  paginaSiguienteEnviados:number;
  paginaAnteriorEnviados:number;
  totalPaginasEnviados:number;
  ordenacion={};


  constructor(private mensajesService:MensajesService, private auth:AuthService,
              private activatedRoute:ActivatedRoute) {
                
    this.ordenacion['campo']="MEfecha";
    this.ordenacion['orden']="DESC";

    this.paginaActualRecibidos=1;
    this.paginaActualEnviados=1;
    this.mensajesEnviados=[];
    this.mensajesRecibidos=[];
  }

  ngOnInit() {
    
    
    
    this.activatedRoute.queryParams.subscribe(params=>{
      if(params.tipo=="nuevos"){
        this.mensajesService.getMensajesNoLeidos(this.auth.usuarioActivo, this.ordenacion).subscribe(resp=>{
          this.mensajesRecibidos=resp["mensajesRecibidos"];
          if(this.mensajesRecibidos.length==0){
            this.cargarMensajesRecibidos(this.paginaActualRecibidos);
          }
        });
      }else{
        this.cargarMensajesRecibidos(this.paginaActualRecibidos);
      }
      this.cargarMensajesEnviados(this.paginaActualEnviados);
    })
  }

  cargarMensajesEnviados(pagina){
    this.mensajesService.getMensajesEnviados(this.auth.usuarioActivo, pagina, this.ordenacion)
    .subscribe(resp=>{
      this.mensajesEnviados=resp["mensajes"];
      this.paginaActualEnviados=parseInt(resp["pagina"]);
      this.paginaAnteriorEnviados=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteEnviados=parseInt(resp["pag_siguiente"]);
      this.totalPaginasEnviados=parseInt(resp["total_paginas"]);
    });
  }
  
  cargarMensajesRecibidos(pagina){
    this.mensajesService.getMensajesRecibidos(this.auth.usuarioActivo, pagina, this.ordenacion)
    .subscribe(resp=>{
      this.mensajesRecibidos=resp["mensajes"];
      this.paginaActualRecibidos=parseInt(resp["pagina"]);
      this.paginaAnteriorRecibidos=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteRecibidos=parseInt(resp["pag_siguiente"]);
      this.totalPaginasRecibidos=parseInt(resp["total_paginas"]);
    });
  }

  previousPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaAnteriorRecibidos);
  }

  previousPageEnviados(){
    this.cargarMensajesEnviados(this.paginaAnteriorEnviados);
  }

  nextPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaSiguienteRecibidos);
  }

  nextPageEnviados(){
    this.cargarMensajesEnviados(this.paginaSiguienteEnviados);
  }

  marcarMensajeLeido(cod){
    this.mensajesService.marcarMensajeLeido(cod).subscribe();
  }
  

  eliminarMensajeRecibido(codigo){
    if(confirm("¿Desea borrar el mensaje seleccionado?")){
      this.mensajesService.eliminarMensajeRecibido(codigo).subscribe(resp=>{
        this.cargarMensajesRecibidos(this.paginaActualRecibidos);
      });
    }
    
  }

  eliminarMensajeEnviado(codigo){
    if(confirm("¿Desea borrar el mensaje seleccionado?")){
      this.mensajesService.eliminarMensajeEnviado(codigo).subscribe(resp=>{
       this.cargarMensajesEnviados(this.paginaActualEnviados);
      });
    }
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    this.cargarMensajesEnviados(this.paginaActualEnviados);
    this.cargarMensajesRecibidos(this.paginaActualRecibidos);
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/mensajes/mensajes.component.ts